import { FavoriteAd } from "components/FavouritesList/types";
import { FavouriteAdDetails, FavouriteDealer, Favourite, Listing } from "./types";
import { extractShortContactOptions } from "./mapProductToOffering";

export function extractAdDetails(product: FavoriteAd): FavouriteAdDetails {
    const { price, title, aantalFotos, datumGeplaatst, id } = product || {};

    return {
        name: title, // Car name (e.g. Kia Picanto 1.0 T-GDi GT-Line 5p)
        price,
        advertisementID: id,
        publishDate: datumGeplaatst, // Date car was published (e.g. 2020-12-10T14:53:40Z)
        picturesAmount: aantalFotos,
        publishStatus: product?.publishStatus // optionality here because favourites are so loosely typed
    };
}

export function extractDealer(product: FavoriteAd): FavouriteDealer {
    const { aanbiederId, soort: aanbiedersoort } = product?.aanbieder || {};

    return {
        dealerID: aanbiederId || -1, // ID of car dealer (e.g. 18075)
        dealerType: aanbiedersoort || "" // Type of car dealer (e.g. officiele_merkdealer)
    };
}

export function mapProductToFavourite(product: FavoriteAd, productPosition = 0): Favourite {
    const adDetails = extractAdDetails(product);

    const dealer = extractDealer(product);
    const contactOptions = extractShortContactOptions(product);

    const listing: Listing = {
        list: "favourites",
        position: productPosition // Position on the list	(e.g. 4)
    };

    return {
        adDetails,
        dealer,
        contactOptions,
        listing
    };
}
